export default { "type": "FeatureCollection", "features": [
        { "type": "Feature", "geometry": { "type": "Polygon", "coordinates": [[[-68.6421, 11.9788], [-68.6435, 11.9784], [-68.6435, 11.983], [-68.6443, 11.9846], [-68.644, 11.9854], [-68.6454, 11.9879], [-68.6462, 11.9887], [-68.647, 11.9935], [-68.6474, 11.9943], [-68.6474, 11.9966], [-68.6485, 11.9982], [-68.6482, 11.9996], [-68.6448, 11.9999], [-68.6418, 11.9984], [-68.64, 11.9956], [-68.6401, 11.9929], [-68.6393, 11.9912], [-68.6399, 11.9889], [-68.6401, 11.9853], [-68.6399, 11.9833], [-68.6408, 11.9807], [-68.6421, 11.9788]]] }, "properties": { "name": "Curaçao", "id": "CW", "CNTRY": "Curaçao", "TYPE": "Constituent" }, "id": "CW" }
    ] };



//////////////////
// WEBPACK FOOTER
// ../geodata/es2015/curacaoLow.js
// module id = null
// module chunks = 